import axios from "axios";
import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import Submit from "../components/Submit";
import { updateLoading } from "../store/reducers/loading";
import { color, intaglio, levelBtn, overflowY, pageSetting } from "../styles/theme";

const BugReport = () => {
	const data = {
		title: "solidity reentrancy attack suspected.",
		severity: "Critical",
		environment: `MacOS Monteray v12.1.1\nNode v14\nSolidity ^0.5.0`,
		sourceCode: `function withdrawAll() external {
			uint256 balance = getUserBalance(msg.sender);
			require(balance > 0, "Insufficient balance");

			(bool success, ) = msg.sender.call{value: balance};
			require(success, "Failed to send Ether");
			
			userBalances[msg.sender] = 0;
		}
		`,
		description: `The Reentrancy attack is one of the most destructive attacks in the Solidity smart contract. A reentrancy attack occurs when a function makes an external call to another untrusted contract. Then the untrusted contract makes a recursive call back to the original function in an attempt to drain funds.

When the contract fails to update its state before sending funds, the attacker can continuously call the withdraw function to drain the contract’s funds. A famous real-world Reentrancy attack is the DAO attack which caused a loss of 60 million US dollars.`,
		reproduce: `1. Login as Admin \n2. Go to a course page \n3. Turn editing on \n4. Add a "Label" resource \n5. On the following page, enter some arbitrary label text \n6. Press the Save button`,
		expectedResult: "On the following page, a newly created label is displayed on the course page",
		actualResult: "On the following page, the label is not displayed on the course page",
		attechedFile: "",
	};

	const dispatch = useDispatch();

	const onClickHandler = async () => {
		dispatch(updateLoading(true));
		const uploadObj = { ...data, projectName: "makerDAO" };

		await axios.post("http://localhost:4000/api/bugreport", uploadObj, {
			headers: {
				"Content-Type": "application/json",
			},
		});
		dispatch(updateLoading(false));
	};

	return (
		<BugReportSection>
			<div className="title">
				<span>Title</span>
				<h2>{data.title}</h2>

				<div className="lowBox">
					<span style={{ marginBottom: "1rem" }}>Bug ID : 6381ce1a69dfc02d934c97aa</span>
					<span>2022-11-23</span>
				</div>

				<div className="level" style={{ background: color.red }}>
					{data.severity}
				</div>
			</div>

			<DescriptBox>
				<h2>Environment</h2>
				<ul>
					<li>MacOS Monteray v12.1.1</li>
					<li>Node v14</li>
					<li>Solidity ^0.5.0</li>
				</ul>
			</DescriptBox>

			<DescriptBox>
				<h2>Source code</h2>
				<ul>{data.sourceCode}</ul>
			</DescriptBox>

			<DescriptBox>
				<h2>Description</h2>
				<ul>{data.description}</ul>
			</DescriptBox>

			<DescriptBox>
				<h2>Steps to reproduce</h2>
				<div
					placeholder="&#10;&#10;"
				/>
				<ul>{data.reproduce}</ul>
			</DescriptBox>

			<DescriptBox>
				<h2>Expected result</h2>
				<ul>{data.expectedResult}</ul>
			</DescriptBox>

			<DescriptBox>
				<h2>Actual result</h2>
				<ul>{data.actualResult}</ul>
			</DescriptBox>

			<DescriptBox>
				<h2>Atteched file</h2>
				<ul></ul>
			</DescriptBox>

			{/* <Submit text="Submit" onClick={() => onClickHandler()} />
			<div style={{ marginTop: "3rem" }}></div> */}
		</BugReportSection>
	);
};

const BugReportSection = styled.section`
	${pageSetting}

	width: 100%;
	padding: 0 20rem;

	.title {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin-top: 6.25rem;
		margin-bottom: 4rem;

		h2 {
			font-size: 2.5rem;
			margin: 0;
		}

		.lowBox {
			display: flex;
			justify-content: space-between;
			margin-top: 3rem;
		}

		.subTitle {
			font-size: 2rem;
			line-height: 4rem;
		}

		.level {
			${levelBtn}
		}
	}
`;

const DescriptBox = styled.div`
	width: 100%;
	margin-bottom: 3rem;

	h2 {
		font-size: 1.5rem;
		line-height: 1rem;
	}

	ul {
		${overflowY}
		padding: 1rem 2rem;
		box-sizing: border-box;
		font-size: 1rem;
		background: #262626;
		width: 100%;
		border-radius: 0.4rem;
		outline: none;
		border: none;
		color: ${color.white};
		padding: 1rem 2rem;
		box-sizing: border-box;
		min-height: 5rem;
		white-space: pre-wrap;
		line-height: 2rem;

		li {
			margin-bottom: 1rem;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
`;

export default BugReport;
function dispatch(arg0: any) {
	throw new Error("Function not implemented.");
}
